import ExtendCampaignModal from './ExtendCampaignModal';
import './ExtendCampaignModal.css';
import withRouter from "react-router-dom/withRouter";
import {connect} from "react-redux";
import { bindActionCreators } from 'redux';
import values from 'lodash/values';
import get from 'lodash/get';

import {
    loadIOSForAgency
} from '../../redux/entities/actions';


function mapStateToProps(state,props){
    const campaign = props.campaign
    const ios = campaign ? values(get(state,['entities','ios'],[])).filter(io => io.accountId === campaign.agencyId)
        .sort((a,b) => b.createdDate - a.createdDate) : []
    return {
        ios:ios
    };
}
function mapDispatchToProps(dispatch){
    return bindActionCreators({
        loadIOSForAgency
    },dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExtendCampaignModal));


// WEBPACK FOOTER //
// ./src/shared/components/ExtendCampaignModal/index.js